
import AppCustomLanguageSelect from "@/components/CustomLanguageSelect.vue";
import { ReminderLayoutConf } from "@/models/reminder-layout";
import { ReminderLayout } from "@/utils/reminder-layouts/reminder-layout";
import Vue from "vue";
import { IBreadCrumb, ISelectItem } from "winfakt-vue-components";
import AppPage from "./Page.vue";
import AppTab from "./Tab.vue";
import AppTabs from "./Tabs.vue";
import AppPageContainer from "@/components/layout-editor/PageContainer.vue";
import AppEditorSettingsEdit from "./EditorSettingsEdit.vue";

export default Vue.extend({
	data() {
		return {
			tab: null,
			zoomLevelIndex: 3,
			path: [{
				to: "/settings/reminders/1", value: this.$ct("title")
			}] as IBreadCrumb[],
			selectedLang: "nl-be",
			langModalOpen: false,
			showGrid: false,
			editorSettingsModalOpen: false
		};
	},
	props: {
		layout: Object as () => ReminderLayoutConf
	},
	computed: {
		zoomLevels(): number[] {
			return [25, 50, 75, 100, 150, 200, 400];
		},
		zoomLevel(): number {
			return this.zoomLevels[this.zoomLevelIndex];
		},
		reminderLayout(): ReminderLayout {
			return this.layout.Data;
		},
		buttonBarItmes():ISelectItem<Function>[] {
			return [
				{
					text: this.$ct("changeDisplayLanguage").toString(),
					value: this.openChangeLanguage
				},
				{
					text: this.$ct("edit-editor-settings"),
					value: this.openEditorSettingsModal
				},
				{
					text: this.showGrid ?  this.$ct("hide-grid").toString() : this.$ct("show-grid").toString(),
					value: this.toggleGrid
				},
			];
		}
	},
	methods: {
		save() {
			this.$emit("save");
		},
		zoomOut() {
			if (this.zoomLevelIndex > 0) {
				this.zoomLevelIndex--;
			}
		},
		zoomIn() {
			if (this.zoomLevelIndex < this.zoomLevels.length - 1) {
				this.zoomLevelIndex++;
			}
		},
		openChangeLanguage() {
			this.langModalOpen = true;
		},
		closeLangModal() {
			this.langModalOpen = false;
		},
		triggerDropdown(event: any) {
			if (!event) return;
			event();
		},
		openEditorSettingsModal(){
			this.editorSettingsModalOpen = true;
		},
		toggleGrid(){
			this.showGrid = !this.showGrid;
		}
	},
	async mounted() {
		this.path.push({to: "/settings/reminder-layout/", value: ""});
	},
	components: {
		AppTabs,
		AppPage,
		AppTab,
		AppCustomLanguageSelect,
		AppPageContainer,
		AppEditorSettingsEdit
	},
	i18nEx: {
		componentPrefix: "components.reminder-layout-editor"
	},
});
